declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, SavePurchaseOrderRequest, PurchaseOrderItemRequest, MaterialHistoryController, GetMaterialHistoryRequest, GenericProcPostRequest, S_Methods, } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { Time } from '@angular/common';
const isNullOrUndefined = (val: any) => val === null || val === undefined;

@Component({
  selector: 'editPOVIitems',
  templateUrl: './editPOVIitems.modal.html',
  styleUrls: ['./editPOVIitems.modal.scss']
})

export class NgbEditPOVIitemsModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
  @Input() FromScreen: string;
  @Input() PurchaseOrderData: SavePurchaseOrderRequest;
  @Input() PurchaseOrderItem: PurchaseOrderItemRequest;
  @Input() VendorName: string;
  @Input() VendorCode: number;
  //public TotalOrderQuantity: number;
  //public Tax: any
  TodayDate = new Date();
  isRequesting: boolean;
    ApiResData: any;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
    private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {
    this.Pack();
    //this.PurchaseOrderItem.Pack = 1;
    this.Discount();

    //this.PurchaseOrderItem.Tax = this.Tax
    //alert(this.PurchaseOrderData.SupplierCode);
    //this.PurchaseOrderItem.TotalOrderQuantity = (+this.PurchaseOrderItem.BonusQuantity) + (+this.PurchaseOrderItem.Quantity);
  }
  Pack() {
    if (this.PurchaseOrderItem.Pack == null) {
      this.PurchaseOrderItem.Pack = 1;
    }
  }
  Discount() {
    if (this.PurchaseOrderItem.PurchasePrice == null && this.PurchaseOrderItem.DiscountPercent == null) {
      this.PurchaseOrderItem.DiscountPercent = 0;
      this.PurchaseOrderItem.Discount = 0;
    }
    else {
      this.PurchaseOrderItem.Discount = ((this.PurchaseOrderItem.Quantity) * this.PurchaseOrderItem.PurchasePrice * this.PurchaseOrderItem.DiscountPercent) / 100;
    }
  }
  DiscountEvent(event: any) {
    if (event != null) {
      this.PurchaseOrderItem.Discount = ((this.PurchaseOrderItem.Quantity) * this.PurchaseOrderItem.PurchasePrice * this.PurchaseOrderItem.DiscountPercent) / 100;      
    }
  }
  RecentOrders() {
    this.LoadMaterialHistory();
  }
  CurrentMaterialHistoryController: MaterialHistoryController[];
  CurrentMaterialHistoryController2: MaterialHistoryController;
  LoadMaterialHistory() {
    var getReq = new GetMaterialHistoryRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101022;
    getReq.FacilityCode = AppData.Instance().SelectedBranchCode;
    //alert(this.CurrentBillDetails.ItemCode);
    getReq.MaterialCode = this.PurchaseOrderItem.ItemCode;
    getReq.VendorCode = this.VendorCode;
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101022;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentMaterialHistoryController = JSON.parse(data);
          this.CurrentMaterialHistoryController2 = JSON.parse(data);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.CopyMaterialHistoryToPurchaseOrderItem();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  CopyMaterialHistoryToPurchaseOrderItem() {
    this.PurchaseOrderItem.TaxPercent = this.CurrentMaterialHistoryController2.TaxPercent;
    this.PurchaseOrderItem.UomName = this.CurrentMaterialHistoryController2.UomName;
    this.PurchaseOrderItem.Pack = this.CurrentMaterialHistoryController2.Pack;
    this.PurchaseOrderItem.Mrp = this.CurrentMaterialHistoryController2.MRP;

  }
  //Qunatitychange() {
  //  this.PurchaseOrderItem.TotalOrderQuantity
  //}
  //Qunatitychange(event: any) {
  //  if (event != null) {
      
  //    this.PurchaseOrderItem.TotalOrderQuantity = event;
  //  }
  //}
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
